<template>
  <Transition name="fade">
    <div
      v-if="props.visible"
      class="progress-modal-overlay"
      @click.self="false"
    >
      <div class="progress-modal-container">
        <div class="progress-modal-card">
          <!-- 헤더 -->
          <div class="progress-modal-header">
            <i class="fa-regular fa-circle-up me-2 text-primary"></i>
            <span class="progress-modal-title">펌웨어 업데이트 중</span>
          </div>

          <!-- 본문 -->
          <div class="progress-modal-body">
            <div class="progress-info">
              <div class="progress-percent-display">
                {{ props.percent }}%
              </div>
              <div class="progress-status-block">
                <div class="progress-message">
                  업데이트가 진행 중입니다. 잠시만 기다려주세요...
                </div>
                <!-- 프로그레스 바: 안내 문구와 동일 너비 -->
                <div class="progress-wrapper">
                  <div class="progress progress-modern">
                    <div
                      class="progress-bar progress-bar-modern"
                      :style="`width: ${props.percent}%`"
                      role="progressbar"
                      :aria-valuenow="props.percent"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 경고 메시지 -->
            <div class="progress-warning">
              <i class="fa-solid fa-triangle-exclamation me-2"></i>
              <span>업데이트 중에는 장치를 끄거나 전원을 차단하지 마세요.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: true,
  },
  percent: {
    type: Number,
    default: 10,
  },
});
</script>

<style scoped>
/* 페이드 애니메이션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

/* 오버레이 */
.progress-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

/* 모달 컨테이너 */
.progress-modal-container {
  width: 90%;
  max-width: 500px;
  padding: 1rem;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 모달 카드 */
.progress-modal-card {
  background-color: #ffffff;
  border-radius: 1.2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

/* 헤더 */
.progress-modal-header {
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
}

.progress-modal-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
}

/* 본문 */
.progress-modal-body {
  padding: 1.5rem;
}

.progress-info {
  margin-bottom: 1.5rem;
  text-align: center;
}

.progress-percent-display {
  font-size: 3rem;
  font-weight: 700;
  color: #0d6efd;
  line-height: 1;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 안내 문구 + 프로그레스 바를 같은 너비로 묶음 */
.progress-status-block {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 100%;
  margin-top: 0.5rem;
}

.progress-message {
  font-size: 0.95rem;
  color: #6c757d;
  white-space: nowrap;
}

/* 프로그레스 바 — Mac 부팅 스타일 (가늘고 안내 문구와 동일 너비) */
.progress-wrapper {
  width: 100%;
  margin-top: 0.85rem;
}

.progress-modern {
  height: 4px;
  background-color: #e5e5ea;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: none;
}

.progress-bar-modern {
  height: 100%;
  background: #0d6efd;
  border-radius: 999px;
  transition: width 0.3s ease;
  padding: 0;
  animation: none;
  position: relative;
  overflow: hidden;
}

/* 경고 메시지 */
.progress-warning {
  padding: 0.75rem 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #856404;
}

.progress-warning i {
  color: #ffc107;
  flex-shrink: 0;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .progress-modal-container {
    width: 95%;
    padding: 0.5rem;
  }

  .progress-modal-header {
    padding: 1rem 1.25rem;
  }

  .progress-modal-title {
    font-size: 1rem;
  }

  .progress-modal-body {
    padding: 1.25rem;
  }

  .progress-percent-display {
    font-size: 2.5rem;
  }

  .progress-message {
    font-size: 0.875rem;
    white-space: normal;
  }

  .progress-modern {
    height: 4px;
  }
}
</style>
